import React from 'react';
import { IonCard, IonCardContent, IonButton, IonIcon, IonBadge } from '@ionic/react';
import { checkmarkDoneOutline, addCircleOutline, calendarOutline, personOutline, callOutline } from 'ionicons/icons';
import { updateSalesActivity } from '../services/sales.service';
import useNavigation from '../hooks/useNavigation';

interface IProps {
    activity: any;
    onDismiss: (activityId: string) => void;
}

const SalesActivityFollowUpCard: React.FC<IProps> = ({ activity, onDismiss }) => {
    const navigateTo = useNavigation();

    const clearFollowUpDate = async () => {
        await updateSalesActivity(activity.id, { followUpDate: null });
        onDismiss(activity.id);
    };

    const markDone = async () => {
        await clearFollowUpDate();
    };

    const addFollowUpActivity = () => {
        navigateTo('/tabs/salesActivity', {
            prefillActivity: {
                group: activity.group,
                userIds: activity.userIds?.map((id: any) => typeof id === 'string' ? { farmUserId: id } : id) || [],
                contactPhoneNumber: activity.leadProps?.contactPhoneNumber || '',
                countryCode: activity.leadProps?.countryCode || '+91',
            },
            sourceActivityId: activity.id,
        });
    };

    const followUpDate = activity.followUpDate
        ? new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(activity.followUpDate))
        : '';

    return (
        <IonCard style={{ margin: '8px', borderRadius: '12px' }}>
            <IonCardContent>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                    <span style={{ fontWeight: 600, fontSize: '14px' }}>
                        {activity.salesActivityType?.description || 'Activity'}
                    </span>
                    {followUpDate && (
                        <IonBadge color="warning" style={{ fontSize: '11px' }}>
                            <IonIcon icon={calendarOutline} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
                            {followUpDate}
                        </IonBadge>
                    )}
                </div>

                {activity.comment && (
                    <p style={{ fontSize: '13px', color: '#555', margin: '4px 0 8px' }}>
                        {activity.comment}
                    </p>
                )}

                {activity.userIds?.length > 0 && (
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                        <IonIcon icon={personOutline} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
                        {activity.userIds.map((id: any) => typeof id === 'string' ? id : (id.name || id.farmUserId)).join(', ')}
                    </div>
                )}

                {activity.leadProps?.contactPhoneNumber && (
                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
                        <IonIcon icon={callOutline} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
                        {activity.leadProps.countryCode} {activity.leadProps.contactPhoneNumber}
                    </div>
                )}

                <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                    <IonButton size="small" fill="outline" color="medium" onClick={markDone}>
                        <IonIcon slot="start" icon={checkmarkDoneOutline} />
                        Mark as Done
                    </IonButton>
                    <IonButton size="small" fill="solid" color="primary" onClick={addFollowUpActivity}>
                        <IonIcon slot="start" icon={addCircleOutline} />
                        Add Follow-up Activity
                    </IonButton>
                </div>
            </IonCardContent>
        </IonCard>
    );
};

export default SalesActivityFollowUpCard;
